<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>钱包开关</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="币种开关" name="coin"></el-tab-pane>
        <el-tab-pane label="批量开关" name="batch"></el-tab-pane>
        <el-tab-pane label="撤单开关" name="cancel"></el-tab-pane>
        <el-tab-pane label="手续费设置" name="serviceCharge"></el-tab-pane>
        <el-tab-pane label="入账开关" name="entrySwitch"></el-tab-pane>
      </el-tabs>
      <switch-list v-if="activeTab === 'coin'"></switch-list>
      <batch-switch-list v-if="batchShow"></batch-switch-list>
      <service-charge-list
        v-if="activeTab === 'serviceCharge'"
      ></service-charge-list>
      <entry-switch-list v-if="activeTab === 'entrySwitch'"></entry-switch-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import SwitchList from './components/list';
import BatchSwitchList from './components/batchList';
import ServiceChargeList from './components/serviceChargeSetting';
import EntrySwitchList from './components/entrySwitch';
import { mapActions } from 'vuex';

export default {
  name: 'WalletSwitch',
  components: {
    SwitchList,
    BatchSwitchList,
    ServiceChargeList,
    EntrySwitchList
  },
  data() {
    return {
      activeTab: '',
      batchShow: false
    };
  },
  methods: {
    ...mapActions('walletSwitchSetting', [
      'buildQuerySwitchType',
      'clearBatchSwitchList',
      'batchList',
      'buildCancelTradeList'
    ]),
    handleClick() {
      this.batchShow = false;
      if (this.activeTab === 'batch') {
        this.clearBatchSwitchList();
        this.buildQuerySwitchType(0);
        this.batchList();
        this.batchShow = true;
      }
      if (this.activeTab === 'cancel') {
        this.clearBatchSwitchList();
        this.buildQuerySwitchType(1);
        this.buildCancelTradeList();
        this.batchShow = true;
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
